import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class StorySlide {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    this.slider = null;
    this.autoplayInterval = null;
    this.autoplayDelay = 3000; // 3秒間隔で自動再生
    this.isAutoplayActive = true;
    
    this.option = {
      type: 'loop',
      // カード幅は文言量に合わせて可変（多言語対応）
      autoWidth: true,
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      speed: 900,
      arrows: false,
      pagination: false,
      gap: `min(${20 / 16}rem, ${20 / 375 * 100}vw)`,
      padding: {
        right: `${66 / 375 * 100}vw`,
        left: `${72 / 375 * 100}vw`,
      },
      updateOnMove: true,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          gap: `min(${30 / 16}rem, ${30 / 1440 * 100}vw)`,
          padding: {
            right: `min(${438 / 16}rem, ${438 / 1440 * 100}vw)`,
            left: `min(${335 / 16}rem, ${335 / 1440 * 100}vw)`,
          }
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.slider.mount();
    this.setupAutoplay();
    this.setupEventListeners();
  }

  // 自動再生を開始
  startAutoplay() {
    if (!this.isAutoplayActive) return;
    
    this.autoplayInterval = setInterval(() => {
      if (this.slider && this.isAutoplayActive) {
        this.slider.go('+1');
      }
    }, this.autoplayDelay);
  }

  // 自動再生を停止
  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  // 自動再生を一時停止
  pauseAutoplay() {
    this.isAutoplayActive = false;
    this.stopAutoplay();
  }

  // 自動再生を再開
  resumeAutoplay() {
    this.isAutoplayActive = true;
    this.startAutoplay();
  }

  // 自動再生の初期設定
  setupAutoplay() {
    this.startAutoplay();
  }

  // イベントリスナーの設定
  setupEventListeners() {
    // ホバー時に自動再生を一時停止
    this.dom.el.addEventListener('mouseenter', () => {
      this.pauseAutoplay();
    });

    // ホバー解除時に自動再生を再開
    this.dom.el.addEventListener('mouseleave', () => {
      this.resumeAutoplay();
    });

    // ページが非表示になった時に自動再生を停止
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.pauseAutoplay();
      } else {
        this.resumeAutoplay();
      }
    });
  }

  // クリーンアップ
  destroy() {
    this.stopAutoplay();
    if (this.slider) {
      this.slider.destroy();
    }
  }
}

export default StorySlide